export const TEXT_TYPE_OPTIONS = [
  "STORY",
  "DIALOGUE",
  "CRIME",
  "PODCAST",
  "KNOWLEDGE",
] as const;

export type GeneratedTextType = (typeof TEXT_TYPE_OPTIONS)[number];

export const MVP_CAPABILITIES = {
  enabledTextTypes: ["KNOWLEDGE"] as GeneratedTextType[],
  // The daily-nudge implementation remains available in the codebase, but is
  // intentionally outside the current MVP surface.
  dailyNudgesEnabled: false,
};

export function getEnabledTextTypeOptions() {
  return TEXT_TYPE_OPTIONS.filter((textType) =>
    MVP_CAPABILITIES.enabledTextTypes.includes(textType),
  );
}

export function getDefaultTextType(): GeneratedTextType {
  return MVP_CAPABILITIES.enabledTextTypes[0] ?? "KNOWLEDGE";
}

export function resolveEnabledTextType(value: string | undefined | null) {
  const normalized = (value ?? "").trim().toUpperCase() as GeneratedTextType;
  return MVP_CAPABILITIES.enabledTextTypes.includes(normalized)
    ? normalized
    : getDefaultTextType();
}
